import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=a35d156a&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.css?vue&type=style&index=0&id=a35d156a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35d156a",
  null
  
)

export default component.exports